import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import {
  MessageWrapper,
  StyledHeader,
  StyledContent,
  Paragraph,
} from "./styles/disengaged-styles";

export interface MessageProps {
  disengagedBy: string;
  message?: string;
}

export const Message: FunctionComponent<MessageProps> = ({
  disengagedBy,
  message,
}) => (
  <MessageWrapper>
    <StyledHeader data-testid="disengaged-message-header">
      Disengaged
    </StyledHeader>
    <StyledContent data-testid="disengaged-message-content">
      <Paragraph>
        <strong>{disengagedBy}</strong> has elected to disengage.
        <br />
        Please see message below for futher details.
      </Paragraph>
      <Paragraph message data-testid="disengaged-message">
        {`"${message}"` || "No reason was given."}
      </Paragraph>
    </StyledContent>
  </MessageWrapper>
);

Message.propTypes = {
  disengagedBy: PropTypes.string.isRequired,
  message: PropTypes.string,
};

Message.defaultProps = {
  message: null,
};

export default Message;
